import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_URL, withCredentials: true });

export function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg).join(" · ");
  return typeof detail === "string" ? detail : "Operazione non riuscita. Riprova.";
}